import React from 'react';

import OptimizedImage, { ImageType } from '../common/OptimizedImage';
import PropTypes from 'prop-types';

const DispensaryLogo = ({
  logoImage,
  dispensaryName,
  imgClass,
  wrapStyle
}) => {

  return (
    <div className={wrapStyle} style={{display:'block'}}>
      <OptimizedImage
        imgSrc={logoImage}
        imgAlt={dispensaryName}
        imgClass={imgClass} 
        imgType={ImageType.DISPENSARY_LOGO}
      />
    </div>
  );
} 

DispensaryLogo.propTypes = {
  logoImage: PropTypes.string.isRequired,
  dispensaryName: PropTypes.string.isRequired,
  imgClass: PropTypes.string,
  wrapSytle: PropTypes.string
};

export default DispensaryLogo;